module.exports = __webpack_public_path__ + "media/images/sec_5-2-b910a75a149e15e1d343b8954961bf9d.png";